export class CompositeFilter {
  constructor(...filters) {
    this.filters = filters;
  }
  isLoggable(record) {
    return this.filters.every(filter => filter.isLoggable(record));
  }
  getFilters() {
    return this.filters;
  }
}